import React from 'react'
import styled from 'styled-components'
import { LargeWrapper } from '@raysync/common/components'
import { Devices } from '@raysync/common/theme'
import { Title, Desc } from '../atoms'
const Section = styled(LargeWrapper)`
  padding: 80px 0 116px;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 1rem;
  }
`

const List = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
`

const Item = styled.div`
  display: flex;
  width: 100%;
  margin-top: 94px;
  justify-content: space-between;
  align-items: center;
  img {
    width: 700px;
    height: 360px;
  }
  &:nth-child(even) {
    flex-direction: row-reverse;
  }
  @media ${Devices.phone} {
    margin-top: 0.2rem;
    flex-wrap: wrap;
    justify-content: unset;
    align-items: unset;
    flex-direction: unset !important;
    img {
      width: 100%;
      height: unset;
      margin-top: 0.6rem;
    }
  }
`

const ContentBox = styled.div`
  max-width: 620px;
  h3 {
    position: relative;
    font-size: 24px;
    font-weight: bold;
    color: ${p => p.theme.color.secondary};
    line-height: 1.2;
    margin-bottom: 40px;
    &::after {
      position: absolute;
      left: 0;
      top: 40px;
      content: ' ';
      display: block;
      width: 50px;
      height: 3px;
      background: ${p => p.theme.color.secondary};
    }
  }
  ul {
    list-style: none;
    color: #788296;
    p {
      color: #636772;
      &:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
  @media ${Devices.phone} {
    max-width: unset;
    margin-top: 0.4rem;
    h3 {
      font-size: 0.36rem;
      line-height: 1.2;
      margin-bottom: 0.4rem;
      &::after {
        top: 0.6rem;
        width: 0.6rem;
        height: 2px;
      }
    }
    ul {
      li {
        font-size: 0.2rem;
      }
    }
  }
`

const Advantages4 = ({ title, desc, items }) => {
  return (
    <Section>
      <Title>{title}</Title>
      <Desc>{desc}</Desc>
      {items && (
        <List>
          {items.map((item, index) => (
            <Item key={index}>
              <img src={item.img} alt={item.title} />
              <ContentBox>
                <h3>{item.title}</h3>
                <ul>{item.desc}</ul>
              </ContentBox>
            </Item>
          ))}
        </List>
      )}
    </Section>
  )
}

export default Advantages4
